import ProductGroupingPartialsLogo from "./ProductGroupingPartialsLogo.component";

export default ProductGroupingPartialsLogo;
